/**
 * How a delivered video is named wherever it is referred to.
 *
 * Keyed on the delivery id, NOT the hook number: hook_number is only filled in
 * meaningfully by the bulk delivery path, which numbers hooks by their index in
 * one submission. Deliveries created one at a time all land on the default of 1,
 * so a request with three single-entry deliveries showed "Hook 1" three times.
 * The id is the only stable, unique handle.
 *
 * Shared on purpose: the reviewer ticks a delivery in the QC panel, reads it
 * again on the video card, and the agency reads it a third time in the QC
 * history. If those disagreed, "#142 needs changes" would stop being actionable.
 *
 * Accepts either a delivery object or a backend note ref ({ id, hook_name }) —
 * both carry the id and the name.
 */
export const deliveryLabel = (delivery) => {
  const id = delivery?.id ?? null;
  const name = (delivery?.hook_name || "").trim();
  if (id && name) return `Delivery #${id} · ${name}`;
  if (id) return `Delivery #${id}`;
  return name || "Delivery";
};

export default deliveryLabel;
